var map = {
	"./chongqing/IMG_3138-min.jpg": "0516",
	"./chongqing/hongyadong.jpeg": "04f4",
	"./japan/IMG_4639-min.jpg": "f2fd",
	"./japan/IMG_4885-min.jpg": "467d",
	"./japan/IMG_5028-min.jpg": "6589"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ddc";